

export const chapter = {
    TYPES: {
        Reading: "Reading",
        Revision: "Revision",
        Reference: "Reference",
        Additional: "Additional"
    },
    CONTENT_TYPES: {
        "Presentation": "Presentation",
        "PDF Content": "PDF Content",
        "Video": "Video",
        "Audio": "Audio",
        "Text": "Text"
    }
}

export const ASSESSMENT_TYPES = {
    UNIT: 'Unit', PERIODIC: 'Periodic', TERM: 'Term'
}

export const LEVELS = {
    BEGINNER:"Beginner", INTERMEDIATE:"Intermediate", ADVANCED:"Advanced"
}

export const TOPICS = {
    LINES: "Lines"
}

const GENERATION = [ "1", "2" ,"3"]

const QUESTION_LEVELS = [ "1","2","3","4","5"]

const TAXONOMY = [ "LOW", "MEDIUM", "HIGH" ]

const CATEGORY = [ "DIRECT", "APPLICATION", "SYNTHESIS" ]

const DEMOGRAPHY = {
    "rural":"Rural",
    "urban" :"Urban"
}

const GRADES = {
    "1"  : "Grade 1",
    "2"  : "Grade 2",
    "3"  : "Grade 3",
    "4"  : "Grade 4",
    "5"  : "Grade 5",
    "6"  : "Grade 6",
    "7"  : "Grade 7",
    "8"  : "Grade 8",
    "9"  : "Grade 9",
    "10" : "Grade 10",
}

export const generateConstants = {
    QUESTION_LEVELS,
    TAXONOMY,
    CATEGORY,
    GENERATION,
    GRADES,
    DEMOGRAPHY
}


// export const SECTION_TYPE = {
//     Story: "Story",
//     Course: "Course",
// }

export const SECTION_TYPE = [
    {
        sectionType:"Story Reading Assisted",
        chapterTypes:[
            { 
                type:'Recap'
            },
            { 
                type:'Story with Keywords'
            },
            { 
                type:'Pronounciation Summary'
            },
            { 
                type:'Assessment'
            },
        ]
    },
    {
        sectionType:"Concept Module",
        chapterTypes:[
            { 
                type:'Recap'
            },
            { 
                type:'Assessment'
            },
        ]
    },
    {
        sectionType:"Story Reading Evaluation",
        chapterTypes:[
            { 
                type:'Story with Keywords'
            },
            { 
                type:'Pronounciation Summary'
            },
        ]
    },
    {
        sectionType:"Comprehension",
        chapterTypes:[
            { 
                type:'Assessment'
            },
        ]
    },
    {
        sectionType:"Concept Module - Punctuation",
        chapterTypes:[
            { 
                type:'Recap'
            },
            { 
                type:'Assessment'
            },
        ]
    },
    {
        sectionType:"Story Reading Recording",
        chapterTypes:[
            { 
                type:'Story'
            },
        ]
    },
    {
        sectionType:"Teacher led Session",
        chapterTypes:[
            { 
                type:'Activities'
            },
        ]
    },
]
